import { Logo } from '@/components/logo';

interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = 'Loading QuantForge...' }: LoadingScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-navy-900 transition-all duration-300">
      <div className="flex flex-col items-center space-y-6">
        <div className="w-16 h-16 bg-teal-500/10 rounded-2xl flex items-center justify-center">
          <Logo className="text-teal-400 h-8 w-8 animate-pulse" />
        </div>
        <div className="flex flex-col items-center space-y-3">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-400"></div>
          <p className="text-slate-400 text-sm font-medium">{message}</p>
        </div>
      </div>
    </div>
  );
}
